import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import Header from "../../components/header/Header";
import { Form, Col, Row, Image } from "react-bootstrap";

const Default = ({ children }) => {
  const user = useSelector((state) => state.user);
  const admin = useSelector((state) => state.admin);
  const { userDetail } = user;
  return (
    <>
      <div className="wrapper">
        <Header />
        <div className="topspace">
          <Container>{children}</Container>
        </div>
      </div>
      {!admin?.isAdminLoggedIn && (
        <div
          id="footer"
          style={{
            bottom: "0",
            width: "100%",
            overflowX: "hidden",
            // padding: "10px 20px",
            // paddingTop: "20px",
            alignItems: "center",
            background: "#855DD9",
            color: "white",
            fontWeight: "400",
          }}
        >
          <Row className="overflow-hidden align-center ">
            <Col md="6" className=" d-flex justify-content-center  ">
              <Form.Group
                className="text-center forgetLink me-4"
                controlId="formBasicPassword"
              >
                <a
                  style={{ textDecoration: "none", color: "#fff" }}
                  href="/terms-and-conditions"
                  target="_blank"
                >
                  Terms & Condition
                </a>
              </Form.Group>
              <Form.Group
                className="text-center forgetLink"
                controlId="formBasicPassword"
              >
                <a
                  style={{ textDecoration: "none", color: "#fff" }}
                  href="/privacy-notice"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </Form.Group>
            </Col>
            <Col md="6" className=" imgLogo">
              <Form.Group
                className="align-right forgetLink"
                controlId="formBasicPassword"
              >
                &copy; 2025 Provide Enterprises Ltd. All rights reserved
              </Form.Group>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default Default;
